export default "__VITE_ASSET__CRZ$Cc$B__"